const {isDutchHoliday} = require('@devmen/moment-feestdagen');

export default {
    methods: {
        // Calculates the dates within a range
        // IN: startIndexFromToday: number => -1 for yesterday, 0 for today, 1 for tomorrow, etc.
        // IN: numberOfDaysToTake: number => -1 for 1 day in history, 0 for just the start date, 1 for 1 day in future
        // IN: includeWeekends: boolean
        // IN: includeHolidays: boolean (only official holidays)
        // OUT: array of javascript dates
        getDatesWithinRangeFromToday(startIndexFromToday, numberOfDaysToTake, includeWeekends, includeHolidays) {
            const returnDates = [];
            // Get start date
            let startDate = this.getNextDate(new Date(), startIndexFromToday, includeWeekends, includeHolidays);
            returnDates.push(startDate);
            if (numberOfDaysToTake > 0) {
                let previousDate = startDate;
                for (let i = 0; i < numberOfDaysToTake; i++) {
                    const nextDate = this.getNextDate(previousDate, 1, includeWeekends, includeHolidays);
                    returnDates.push(nextDate);
                    previousDate = nextDate;
                }
            } else if (numberOfDaysToTake < 0) {
                let previousDate = startDate;
                for (let i = 0; i > numberOfDaysToTake; i--) {
                    const nextDate = this.getNextDate(previousDate, -1, includeWeekends, includeHolidays);
                    returnDates.push(nextDate);
                    previousDate = nextDate;
                }
            }
            return _.sortBy(returnDates, date => {
                return moment(date).format('YYYYMMDDHHmmss');
            }, 'asc');
        },
        getNextDate(date, interval = 0, includeWeekends, includeHolidays) {
            let dateToReturn = moment(date).add(interval, 'day');
            // If nothing to exclude:  return the input date
            if (includeWeekends && includeHolidays) {
                return dateToReturn.toDate();
            } else {
                while ((!includeWeekends && dateToReturn.isoWeekday() > 5) || (!includeHolidays && moment(dateToReturn).isDutchHoliday([], true).officialDayOff)) {
                    dateToReturn = moment(dateToReturn).add(interval, 'day');
                }
                return dateToReturn.toDate();
            }
        }
    }
}